import { HotTopicBanner, theme } from '@zappyrent/hundop';
import { graphql } from 'gatsby';
import { I18nextContext, useTranslation } from 'gatsby-plugin-react-i18next';
import { rem } from 'polished';
import React from 'react';
import styled from 'styled-components';

import DiscoverZappyrent from '../components/DiscoverZappyrent';
import Layout from '../components/Layout';
import OurCitiesList from '../components/OurCitiesList';
import OurPartnerships from '../components/OurPartnerships';
import Seo from '../components/Seo';
import TalkingAboutUs from '../components/TalkingAboutUs';
import WhoWeAre from '../components/WhoWeAre';
import ZappyrentNumbers from '../components/ZappyrentNumbers';

const StyledTalkingAboutUs = styled.section`
  margin: ${rem('85px')} 0 ${rem('70px')} 0;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    margin: 0 0 ${rem('105px')} 0;
  }
`;

const StyledZappyrentNumbers = styled.section`
  margin-bottom: ${rem('30px')};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    margin-bottom: ${rem('65px')};
  }
`;

const StyledWhoWeAre = styled.section`
  margin-bottom: ${rem('80px')};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    margin-bottom: ${rem('75px')};
  }
`;

const StyledOurPartnerships = styled.section`
  margin-bottom: ${rem('80px')};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    margin-bottom: ${rem('103px')};
  }
`;

const StyledOurCities = styled.section`
  margin-bottom: ${rem('80px')};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    margin-bottom: ${rem('120px')};
  }
`;

const WhoWeArePage = (): JSX.Element => {
  const { language } = React.useContext(I18nextContext);
  const { t } = useTranslation(['navigation', 'seo']);

  return (
    <Layout
      superHeader={
        <HotTopicBanner
          backgroundColor={theme.colors.landlord.main}
          ctaLabel={t('product:rentWithUs')}
          ctaUrl={`${process.env.GATSBY_SITE_URL}/it/pubblica-annuncio-gratis`}
          firstLabel={t('product:areYouALandlord')}
          secondLabel={t('product:weAlwaysGuaranteeThePaymentOfTheRent')}
        />
      }
      user="tenant"
    >
      <Seo
        canonical={`/${language}/who-we-are`}
        hreflang={`${language}`}
        title={t('seo:titleWhoWeAre')}
        description={t('seo:descriptionWhoWeAre')}
        ogImageUrl={`${process.env.GATSBY_CDN_URL}/opengraph/zappyrent-logo-green-500x500.png`}
        ogImageHeight="500"
        ogImageWidth="500"
      />
      <article>
        <section id="discover-zappyrent">
          <DiscoverZappyrent />
        </section>
        <StyledTalkingAboutUs id="talking-about-us">
          <TalkingAboutUs />
        </StyledTalkingAboutUs>
        <StyledZappyrentNumbers id="zappyrent-numbers">
          <ZappyrentNumbers />
        </StyledZappyrentNumbers>
        <StyledWhoWeAre id="who-we-are">
          <WhoWeAre />
        </StyledWhoWeAre>
        <StyledOurPartnerships id="our-partnerships">
          <OurPartnerships />
        </StyledOurPartnerships>
        <StyledOurCities id="our-cities">
          <OurCitiesList />
        </StyledOurCities>
      </article>
    </Layout>
  );
};

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;

export default WhoWeArePage;
